import React from "react";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";

export const IconReusableComponent = ({
  iconImage,
  iconImageAlt,
  iconImageTitle,
  iconText,
  controlId,
  display,
  name,
  onChange,
  value,
}) => {
  return (
    <React.Fragment>
      <Col className="icon-search-resuable-button">
        <div className="icon-button-box">
          <div className="icon-button-image">
            <Image
              fluid
              src={iconImage}
              alt={iconImageAlt}
              title={iconImageTitle}
            />
          </div>
          <p>{iconText}</p>
        </div>
        {display === true ? (
          <Form.Group className="icon-search-box mb-0" controlId={controlId}>
            <Form inline>
              <Form.Control
                type="search"
                placeholder="Search"
                className="icon-search-box-input"
                name={name}
                onChange={onChange}
                value={value}
              />
            </Form>
          </Form.Group>
        ) : null}
      </Col>
    </React.Fragment>
  );
};

export const ImageTitleReusableComponent = ({
  iconImage,
  imageStyle,
  iconImageAlt,
  iconImageTitle,
  iconText,
}) => {
  return (
    <React.Fragment>
      <div className="page-title-box">
        <div className="icon-button-image">
          <Image
            fluid
            src={iconImage}
            alt={iconImageAlt}
            title={iconImageTitle}
            className={imageStyle}
          />
        </div>
        <p>{iconText}</p>
      </div>
    </React.Fragment>
  );
};

export const ReportDashboardIconComponent = ({
  mainBox,
  onClick,
  mainBoxOne,
  iconImage,
  imageStyle,
  iconImageAlt,
  iconImageTitle,
  iconText,
  iconTitleClass,
  paragraphCss,
}) => {
  return (
    <React.Fragment>
      <div className={mainBox} onClick={onClick}>
        <div className={mainBoxOne}>
          <Image
            fluid
            src={iconImage}
            alt={iconImageAlt}
            title={iconImageTitle}
            className={imageStyle}
          />
        </div>
        <div className={iconTitleClass}>
          <p className={paragraphCss}>{iconText}</p>
        </div>
      </div>
    </React.Fragment>
  );
};
